import { tv } from 'tailwind-variants'

export const tabsRootStyles = tv({
  base: 'flex flex-1 gap-4',
  variants: {
    orientation: {
      vertical: 'flex-row',
      horizontal: 'flex-col',
    },
  },
})

export const tabsListStyles = tv({
  base: 'mb-0 flex items-center gap-2 border-b border-neutral-30 whitespace-nowrap',
  variants: {
    variant: {
      primary: '',
      secondary: 'flex justify-evenly w-full',
      tertiary: 'border-none mb-[-2px]',
    },
    orientation: {
      vertical: 'flex h-full flex-col overflow-y-auto border-b-0 border-r',
      horizontal: 'min-h-fit',
    },
  },
})

export const tabsTriggerStyles = tv({
  base: 'relative group cursor-pointer self-stretch p-2 whitespace-nowrap border-b-2 border-transparent transition-all duration-200 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:border-brand-primary-rest group/tab',
  variants: {
    variant: {
      primary: '',
      secondary: '',
      tertiary: 'p-0 data-[state=active]:border-none',
    },
    orientation: {
      vertical: 'justify-start data-[state=active]:border-b-0 data-[state=active]:bg-brand-primary-light-10',
      horizontal: '',
    },
  },
})

export const inverseBorderStyles = tv({
  slots: {
    rightSide: `after:content-[""] after:absolute before:absolute before:content-[""]
      before:z-4 before:w-[12px] before:h-[12px] before:-right-[8px] before:bottom-0  before:bg-neutral-00 overflow-hidden
      after:z-5  after:w-[12px]  after:h-[16px]  after:-right-[10px] after:bottom-0   after:bg-brand-primary-light-00
      after:border after:border-t-[0px] after:border-r-[0px] after:border-b-[1px] after:border-l-[1px] after:rounded-[0%_60%]`,
    leftSide: `after:content-[""] after:absolute before:absolute before:content-[""]
      before:z-14 before:w-[12px] before:h-[12px] before:-left-[8px] before:bottom-0  before:bg-neutral-00
      after:z-15  after:w-[12px]  after:h-[16px]  after:-left-[11px] after:bottom-[1px]   after:bg-brand-primary-light-00
      after:border  after:border-t-[0px] after:border-r-[1px] after:border-b-[1px] after:border-l-[0px] after:rounded-[60%_0%]`,
  },
})

export const tabsHoverStyles = tv({
  base: 'absolute inset-0 -z-0 m-1 group-hover/tab:bg-button-brand-primary-light-hover group-hover/tab:rounded-xl group-active/tab:bg-button-brand-primary-light-pressed group-hover/tab:group-data-[state=active]/tab:bg-transparent',
})

export const tabsStyles = tv({
  base: 'h-full rounded-b-none md:px-3 py-0 text-neutral-secondary group-data-[state=active]:text-neutral-primary',
  variants: {
    variant: {
      primary: '',
      secondary: 'text-neutral-tertiary group-data-[state=active]:text-scalis-logo-color',
      tertiary:
        'flex select-none items-center rounded-t-xl bg-transparent py-2 px-4 group-data-[state=active]:border group-data-[state=active]:border-neutral-00  group-data-[state=active]:border-b-0 group-data-[state=active]:bg-neutral-00',
    },
  },
})

export const tabsLabelStyles = tv({
  base: 'text-sm/6 font-medium tracking-tighter text-neutral-secondary',
  variants: {
    isActive: {
      true: 'text-brand-primary-10',
    },
  },
})

export const hrStyles = tv({
  base: 'h-3 border-r group-data-[state=active]:border-r-transparent',
  variants: {
    borderless: {
      false: 'border-r-neutral-10',
      true: 'border-r-transparent',
    },
  },
  defaultVariants: {
    borderless: false,
  },
})
